import React, { useEffect } from "react";

export function ModalShell({
                               onClose,
                               children,
                               className,
                           }: {
    onClose: () => void;
    children: React.ReactNode;
    className?: string;
}) {
    useEffect(() => {
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = prev || "auto";
        };
    }, []);

    return (
        <div className="supplies-modal-overlay" onClick={onClose}>
            <div className={`supplies-modal ${className ?? ""}`} onClick={(e) => e.stopPropagation()}>
                {children}
            </div>
        </div>
    );
}
